import {VetologyBase} from "../Vetology/VetologyBase";

export class ClinicManager extends VetologyBase
{
    constructor()
    {
        super('ClinicManager');
    }

    init()
    {
	    const _self = this;
	    if (!document.querySelector('form.clinic-manager')) {
		    return;
	    }

	    const clinicIdInput = document.querySelector('input[name="cid"]');
	    const clinicID = clinicIdInput.value;
	    const queryString = new URLSearchParams();
	    queryString.append('clinicID', clinicID);
	    fetch('/clinic/manage/get-custom-logo-info?' + queryString.toString(),
		    {
			    method: 'get',
			    accept: 'json'
		    }).then((response) => {
		    if (response.ok) {
			    response.json().then(data => {
				    if (data.success) {
					    const imageHandler = document.querySelector('div.imageHandler');
					    const html = data.html;

					    const customLogoMarkup = document.querySelector(".custom-logo-markup");
					    _self.placeMarkupBeforeImage(customLogoMarkup);
				    }
			    });
		    }
			});
		
		const genAiRptsInput = document.querySelectorAll('label:has(input[name="generate_ai_reports"])');
		genAiRptsInput.forEach(input => {
			input.addEventListener('click', this.handleGenerateAiReportsChange.bind(this));
		});
	}
	
	handleGenerateAiReportsChange(event) {
		const value = event.currentTarget.querySelector('input[name="generate_ai_reports"]').value;
		const reportLayoutSwitch = document.querySelector('div.btn-group:has(input[name="report_layout"])');
		if (value === '1') {
			reportLayoutSwitch.classList.remove('disabled');
		} else {
			reportLayoutSwitch.classList.add('disabled');
		}

	}

    placeMarkupBeforeImage(markupElement)
    {
        const logoElem = document.querySelector("img.img_GooglePlaceIDLogo");
        logoElem.parentElement.insertBefore(markupElement, logoElem);
    }

}

